import React, {
    useEffect,
    useState
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { format, subDays } from 'date-fns'
import ParkingPermitRepository from "../../../repositories/ParkingPermitRepository";
import {
    buildViewDetailsButton,
    EventDateColumnType,
} from "../../../components/Grid/Columns";
import { saveAs } from 'file-saver'
import Filter from "./Filter";
import ParkingPermitDetailsView from "../View";

const ParkingPermitListView = () => {

	const repository = new ParkingPermitRepository();
	const {t}  = useTranslation();
	const [openedId, setOpenedId] = useState(null);
	const [blockedWindow, setBlockedWindow] = useState(false);

	const onViewHandler = (e) => {
	    setOpenedId(e.Id);
    }

    const handleOnDownload = async (e) => {
	    setBlockedWindow(true);
	    try {
            const response = await repository.export(Object.assign({}, filter, { sort: sort }));
            saveAs(response.data, 'events.csv');
        } catch (e) {
        } finally {
            setBlockedWindow(false);
        }
    }

    const today = format(new Date(), 'yyyy-MM-dd');
    const defaultFilter = { DateFrom: today, DateTo: today };

    const defaultSort = 'Id|desc';

	const {items,
        totalCount,
        itemsOnPage,
        onPage,
        isSearching,
        onFilterChangedHandler,
        onSortChangedHandler,
        filter,
        sort,
        setFilterValue,
        updateGrid } = useGrid(repository, { defaultFilter: defaultFilter, defaultSort: defaultSort });

	const columns = [
        { field: 'Id', headerName: t('ID'), width: 100, sortable: false },
        { field: 'System', headerName: t('System'), width: 130, sortable: false },
        { field: 'ParkingZones', headerName: t('Parking zone'), width: 200, sortable: false,
            renderCell: ({value}) => {
                return value ? value.join(",") : ''
            }
        },
        { field: 'NumberPlate', headerName: t('Number plate'), width: 120, sortable: false },
        { field: 'StartDate', type: "dateTime", headerName: t('Start date'), ... EventDateColumnType },
        { field: 'EndDate', type: "dateTime", headerName: t('End date'), ... EventDateColumnType },
        { field: 'UpdateAt', type: "dateTime", headerName: t('Timestamp'), ... EventDateColumnType },
        { headerName: t('Actions'), field: 'view', ... buildViewDetailsButton(onViewHandler) }
    ];

	return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <>
                {openedId && <ParkingPermitDetailsView id={openedId} onClose={e => setOpenedId(null)}/> }
             <GridSkeleton title={t("Parking permits")}
                          isSearching={isSearching}
                          isBlocked={blockedWindow}
                          header={(<Header onDownload={handleOnDownload} onRefresh={updateGrid} />)}
                          filter={(<Filter filter={filter} onUpdateFilter={setFilterValue} onFilterChangedHandler={onFilterChangedHandler} onSortChangedHandler={onSortChangedHandler} sort={sort} />)}
                          grid={(<DataGrid
                                       disableMultipleSelection={true}
                                       disableColumnFilter
                                       rows={items()}
                                       rowCount={totalCount()}
                                       columns={columns}
                                       pageSize={itemsOnPage}
                                       paginationMode="server"
                                       sortingMode="server"
                                       disableColumnSelector={true}
                                       disableSelectionOnClick={true}
                                       disableColumnMenu={true}
                                       onPageChange={onPage}
                                       rowsPerPageOptions={[itemsOnPage]}
                                       hideFooterSelectedRowCount={true}
                             />)}
            />
        </>
      </MuiPickersUtilsProvider>
	);
};

export default ParkingPermitListView;